import LegalDocument from "./LegalDocument";
import { pub } from "@/lib/pubThemeClasses";

export default function KVKK() {
  return (
    <LegalDocument eyebrow="Yasal" title="KVKK Aydınlatma Metni">
      <p className={`font-sans text-sm leading-relaxed ${pub.muted}`}>
        Bu sayfa yer tutucudur. 6698 sayılı KVKK kapsamında veri sorumlusunun kimliği, işlenen veri kategorileri ve haklarınız
        yakında yayınlanacak açık metinde detaylandırılacaktır.
      </p>
      <p className={`font-sans text-sm leading-relaxed mt-4 ${pub.muted}`}>
        Başvuru ve iletişim için web sitesindeki iletişim kanalları üzerinden bize ulaşabilirsiniz.
      </p>
    </LegalDocument>
  );
}
